// extracted by mini-css-extract-plugin
export var boxItems = "_9n-1";
export var boxItemsLg = "_9n-2";
export var button = "_9n-7";
export var buttonHoverless = "_9n-9";
export var buttonLg = "_9n-8";
export var filterGroupBox = "_9n-0";
export var icon = "_9n-3";
export var iconSecondary = "_9n-6";
export var iconWrapper = "_9n-4";
export var iconWrapperLg = "_9n-5";
export var truncatedLabel = "_9n-a";